/**
 * Yango Plus Subscription Block
 * Handles adding speaker + Yango Plus subscription to cart
 */
(function () {
  const block = document.querySelector('[data-subscription-block]');
  if (!block) return;

  const subscriptionVariantId = block.dataset.subscriptionVariantId;
  const btnSubscribe = block.querySelector('[data-add-with-subscription]');
  const btnNoThanks = block.querySelector('[data-add-without-subscription]');
  const quantityInput = block.querySelector('[data-quantity-input]');
  let isSubmitting = false;

  if (subscriptionVariantId) {
    window.__yasminaSingletonVariantIds = [String(subscriptionVariantId)];
  }

  function getSpeakerVariantId() {
    const hiddenInput = block.closest('form')
      ? block.closest('form').querySelector('[data-variant-id]')
      : document.querySelector('input[name="id"][data-variant-id]');
    return hiddenInput ? hiddenInput.value : null;
  }

  function getQuantity() {
    return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  }

  function getSubscriptionCartItem() {
    if (!subscriptionVariantId) return null;

    var cart = window.__yasminaCartState;
    if (cart && Array.isArray(cart.items)) {
      var existingItem = cart.items.find(function (item) {
        return String(item.variant_id) === String(subscriptionVariantId);
      });
      if (existingItem) return existingItem;
    }

    var domItem = document.querySelector('[data-cart-item-singleton][data-cart-item-variant-id="' + subscriptionVariantId + '"]');
    if (!domItem) return null;

    return {
      variant_id: subscriptionVariantId,
      quantity: parseInt(domItem.querySelector('[data-cart-quantity]')?.value, 10) || 1
    };
  }

  async function hasSubscriptionInCart() {
    if (!subscriptionVariantId) return false;

    if (getSubscriptionCartItem()) return true;

    try {
      var response = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return false;
      var cart = await response.json();
      return Array.isArray(cart.items) && cart.items.some(function (item) {
        return String(item.variant_id) === String(subscriptionVariantId);
      });
    } catch (error) {
      return false;
    }
  }

  function setButtonsDisabled(disabled) {
    [btnSubscribe, btnNoThanks].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.origHtml = btn.innerHTML;
      var main = btn.querySelector('.yp-subscription__btn-main, .yp-pro__btn-main');
      if (main) {
        main.textContent = 'Adding...';
        var sub = btn.querySelector('.yp-subscription__btn-sub');
        if (sub) sub.style.display = 'none';
      } else {
        btn.textContent = 'Adding...';
      }
    } else {
      if (btn.dataset.origHtml) {
        btn.innerHTML = btn.dataset.origHtml;
        delete btn.dataset.origHtml;
      }
    }
  }

  function openCartDrawer(responseData) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && responseData) {
      cartDrawer.renderContents(responseData);
    } else if (cartDrawer) {
      cartDrawer.classList.add('sf-cart-opened');
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    }

    // Update cart count from response data (no extra fetch needed)
    if (responseData && responseData.item_count !== undefined) {
      var cartCount = document.querySelectorAll('[data-cart-count]');
      cartCount.forEach(function (el) {
        el.textContent = responseData.item_count;
        el.style.display = responseData.item_count > 0 ? 'flex' : 'none';
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: responseData }));
    }
  }

  async function parseCartResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const isJsonLikeResponse =
      contentType.includes('application/json') ||
      contentType.includes('text/javascript') ||
      contentType.includes('application/javascript');

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        response.status === 429
          ? 'Too many cart requests. Please wait a second and try again.'
          : errorText || 'Error adding to cart'
      );
    }

    if (!isJsonLikeResponse) {
      const text = await response.text();
      throw new Error(
        text.includes('Verifying your connection')
          ? 'Cart request was blocked by site protection. Please wait a moment and try again.'
          : 'Unexpected cart response'
      );
    }

    const text = await response.text();

    try {
      return JSON.parse(text);
    } catch (error) {
      throw new Error('Failed to parse cart response');
    }
  }

  async function addToCart(items) {
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: items };

    if (cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    var response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    var data = await parseCartResponse(response);

    if (data.status) {
      throw new Error(data.description || data.message || 'Error adding to cart');
    }

    return data;
  }

  if (btnSubscribe) {
    btnSubscribe.addEventListener('click', async function (e) {
      e.preventDefault();
      if (isSubmitting) return;

      var speakerVariantId = getSpeakerVariantId();
      if (!speakerVariantId) return;

      isSubmitting = true;
      setButtonsDisabled(true);
      setButtonLoading(btnSubscribe, true);

      try {
        var yangoMap = window.__yangoVariantMap;
        var hasSubscriptionAlready = await hasSubscriptionInCart();
        var mappedYangoVariantId = (yangoMap && yangoMap[speakerVariantId]) ? yangoMap[speakerVariantId].yangoId : null;
        var quantity = getQuantity();
        var items = [];

        if (subscriptionVariantId && !hasSubscriptionAlready) {
          items.push({ id: parseInt(subscriptionVariantId), quantity: 1 });
        }

        if (!hasSubscriptionAlready) {
          var bundledSpeakerId = mappedYangoVariantId || speakerVariantId;
          // Always add only one bundled speaker line item. Keep a marker for cart-side sync logic.
          items.push({
            id: parseInt(bundledSpeakerId),
            quantity: 1,
            properties: {
              _yp_bundle: 'with-yango',
              _yp_subscription_variant_id: String(subscriptionVariantId || '')
            }
          });
          if (quantity > 1) {
            items.push({ id: parseInt(speakerVariantId), quantity: quantity - 1 });
          }
        } else {
          items.push({ id: parseInt(speakerVariantId), quantity: quantity });
        }

        var data = await addToCart(items);
        openCartDrawer(data);

        if (quantityInput) quantityInput.value = 1;
      } catch (err) {
        console.error('Subscription add to cart error:', err);
        if (window.NotificationManager) {
          window.NotificationManager.error(err.message);
        } else {
          alert(err.message);
        }
      } finally {
        isSubmitting = false;
        setButtonsDisabled(false);
        setButtonLoading(btnSubscribe, false);
      }
    });
  }

  // Hook into setAddToCartEnabled to also disable subscription buttons
  var origSetAddToCartEnabled = window.setAddToCartEnabled;
  if (typeof origSetAddToCartEnabled === 'function') {
    window.setAddToCartEnabled = function (enabled) {
      origSetAddToCartEnabled(enabled);
      [btnSubscribe, btnNoThanks].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !enabled;
        if (!enabled) {
          btn.style.opacity = '0.4';
          btn.style.pointerEvents = 'none';
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.style.opacity = '';
          btn.style.pointerEvents = '';
          btn.removeAttribute('aria-disabled');
        }
      });
      var counter = block.querySelector('.yp-subscription__counter, [data-yp-pro-counter]');
      if (counter) {
        counter.style.pointerEvents = enabled ? '' : 'none';
        counter.style.opacity = enabled ? '' : '0.4';
      }
    };
  }

  // Watch for variant changes to update speaker price display
  var hiddenInput = block.closest('form')
    ? block.closest('form').querySelector('[data-variant-id]')
    : document.querySelector('input[name="id"][data-variant-id]');

  var proPricing = null;
  var proPricingEl = block.querySelector('[data-yp-pro-pricing]');
  if (proPricingEl) {
    try {
      proPricing = JSON.parse(proPricingEl.textContent);
    } catch (error) {
      proPricing = null;
    }
  }

  function formatCents(cents) {
    return String(cents % 100).padStart(2, '0');
  }

  // PRO block: every figure on the card comes from the matching `*-with-yango`
  // variant, so a colour switch has to repaint price, compare, discount, tabby,
  // the PRO uplift and the speaker-only button in one go.
  function updateProPrices(variantId) {
    if (!proPricing) return false;
    var row = proPricing[variantId];
    if (!row) return false;

    function setText(selector, value) {
      var el = block.querySelector(selector);
      if (el) el.textContent = value;
    }

    setText('[data-yp-pro-price]', Math.floor(row.pro / 100));
    setText('[data-yp-pro-price-cents]', formatCents(row.pro));
    setText('[data-yp-pro-tabby]', row.tabby);
    setText('[data-yp-pro-uplift]', Math.floor((row.pro - row.speaker) / 100));
    setText('[data-speaker-price-display]', Math.floor(row.speaker / 100) + '.' + formatCents(row.speaker));

    var compareWrap = block.querySelector('[data-yp-pro-compare-wrap]');
    var discountWrap = block.querySelector('[data-yp-pro-discount-wrap]');
    var hasCompare = row.compare > row.pro;

    if (hasCompare) {
      setText('[data-yp-pro-compare]', Math.floor(row.compare / 100));
      setText('[data-yp-pro-compare-cents]', formatCents(row.compare));
      setText('[data-yp-pro-discount]', row.discount);
    }
    if (compareWrap) compareWrap.hidden = !hasCompare;
    if (discountWrap) discountWrap.hidden = !hasCompare;

    return true;
  }

  if (hiddenInput) {
    function updateSubscriptionPrices(variantId) {
      if (updateProPrices(variantId)) return;

      var yangoMap = window.__yangoVariantMap;
      var priceDisplay = block.querySelector('[data-speaker-price-display]');
      var subPriceAmount = block.querySelector('.yp-subscription__price-amount');

      if (yangoMap && yangoMap[variantId]) {
        if (priceDisplay) {
          priceDisplay.textContent = yangoMap[variantId].regularPrice;
        }
        if (subPriceAmount) {
          subPriceAmount.textContent = yangoMap[variantId].yangoPrice;
        }
      } else {
        // Fallback: copy from main price display
        if (priceDisplay) {
          var priceMain = document.querySelector('.price__title-span-main:not(.is-bottom)');
          if (priceMain) {
            priceDisplay.textContent = priceMain.textContent.trim();
          }
        }
      }
    }

    var observer = new MutationObserver(function () {
      updateSubscriptionPrices(hiddenInput.value);
    });
    observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

    var origValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(hiddenInput, 'value', {
      get: function () { return origValue.get.call(this); },
      set: function (val) {
        origValue.set.call(this, val);
        updateSubscriptionPrices(val);
      }
    });
  }

  if (btnNoThanks) {
    btnNoThanks.addEventListener('click', async function (e) {
      e.preventDefault();
      if (isSubmitting) return;

      var speakerVariantId = getSpeakerVariantId();
      if (!speakerVariantId) return;

      isSubmitting = true;
      setButtonsDisabled(true);
      var origText = btnNoThanks.textContent;
      btnNoThanks.textContent = 'Adding...';

      try {
        var items = [
          { id: parseInt(speakerVariantId), quantity: getQuantity() }
        ];

        var data = await addToCart(items);
        openCartDrawer(data);

        if (quantityInput) quantityInput.value = 1;
      } catch (err) {
        console.error('Speaker-only add to cart error:', err);
        if (window.NotificationManager) {
          window.NotificationManager.error(err.message);
        } else {
          alert(err.message);
        }
      } finally {
        isSubmitting = false;
        setButtonsDisabled(false);
        btnNoThanks.textContent = origText;
      }
    });
  }
})();
